import { Trans } from '@lingui/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useGetLinks } from 'shared/domains/urls';
import { StyledListItem } from './styled';
export function ContactSupport() {
    const { contact } = useGetLinks();
    return (<StyledListItem as="a" href={contact} target="_blank" rel="noopener noreferrer">
      <Falcon icon="message"/>
      <Trans comment="Link to legal support">Contact support</Trans>
    </StyledListItem>);
}
